export interface ForemanDailySafetyItem {
  foremanDailySafetyItemID: string;
  foremanSafetyItemID?: string;
  foremanJobID: string;
  dateWorked: string;
  foremanSafetyItemDescription: string;
  isItemCompleted: boolean;
}